import { Svg, type SvgProps } from "./Svg";

export const InfoIconMeme = ({
	height = "24",
	version = "1.1",
	viewBox = "0 0 24 24",
	width = "24",
	xmlns = "http://www.w3.org/2000/svg",
	...rest
}: SvgProps) => {
	return (
		<Svg
			{...rest}
			{...{ height, version, viewBox, width, xmlns }}
			style={{ background: "transparent" }}
		>
			<circle
				cx="12"
				cy="12"
				r="11"
				stroke="currentColor"
				strokeWidth="2"
				fill="transparent"
			/>
			<path
				d="M12 8V12"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<circle cx="12" cy="16" r="1" fill="currentColor" />
		</Svg>
	);
};
